export default __webpack_public_path__ + "static/media/video-instruction.f00862cd.svg";